module.exports = __webpack_public_path__ + "img/bar-2.0a47f2fb.svg";